/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Cash_InflowInputs */

const vi_dashboard_manager_cash_inflow = /** @type {(inputs: Dashboard_Manager_Cash_InflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền vào`)
};

/**

* @param {Dashboard_Manager_Cash_InflowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_cash_inflow = /** @type {((inputs?: Dashboard_Manager_Cash_InflowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Cash_InflowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_cash_inflow(inputs)
});